import { FC } from 'react';

import { IconProps } from '../types';

export const FacebookIcon: FC<IconProps> = ({
	size,
	height = 18,
	width = 10,
	color = '#06519E',
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 10 18"
		width={size ?? width}
		height={size ?? height}
	>
		<path
			fill={color}
			fillRule="evenodd"
			d="M2.933 18H6.42V9.955h2.576l.515-3.25H6.42V4.25c0-.911.872-1.427 1.704-1.427H9.63V.128L6.935.008C4.359-.15 2.933 1.872 2.933 4.289v2.418H0v3.25h2.933V18Z"
		/>
	</svg>
);
